module.exports = __webpack_public_path__ + "static/media/gluten.77926c24.svg";